import React from 'react';
import { Box } from '@mui/system';
import { IconButton } from 'components/Buttons';
import * as Styled from './Arrow.styles';

export enum ArrowDirection {
  RIGHT = 'right',
  LEFT = 'left',
}

type ArrowProps = {
  direction: ArrowDirection;
  onClick: () => void;
  show: boolean;
};

const Arrow: React.FC<ArrowProps> = ({ direction, onClick, show }) => {
  return (
    <Styled.Arrow direction={direction} show={show}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        <IconButton
          onClick={onClick}
          size="small"
          color="secondary"
          iconName={
            ArrowDirection.RIGHT === direction ? 'arrow-right' : 'arrow-left'
          }
        />
      </Box>
    </Styled.Arrow>
  );
};

export default Arrow;
